/**
 * EDIリクエストの申請
 */
import * as httpConst from '../../../constants/httpConst'
import Vue from 'vue'

const API_PATH = `${httpConst.EDI_REQUEST_ENDPOINT}/edi_requests`

const registration = {
  namespaced: true,
  state: {
    // 必要な状態をここに追加
  },
  getters: {
  },
  mutations: {
    resetState(state) {
      // 状態をリセット
    },
  },
  actions: {
    /**
     * registrations情報の取得
     * @param {Object} context - Vuexコンテキスト
     * @param {Object} params - パラメータ
     * @param {string} params.edi_request_token - EDIリクエストトークン
     * @returns {Promise} registrations情報
     */
    index({ commit }, { edi_request_token }) {
      const api_path = `${API_PATH}/${edi_request_token}/registrations`
      return new Promise((resolve, reject) => {
        Vue.$http.get(api_path).then(data => {
          let content = data.content
          resolve(content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    resetState({ commit }) {
      commit('resetState')
    },
  },
}

export default registration
